module.exports = __webpack_public_path__ + "static/media/4-AirHeatExchanger - No cool - El heat.9a5dff99.png";